exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bold[data-v-7f283ef7] {\n  font-weight: bold;\n  font-size: 20px;\n}\n.detailTab[data-v-7f283ef7] {\n  overflow-y: auto;\n}\n.avatarImg[data-v-7f283ef7] {\n  height: 50px;\n}\n", ""]);

// exports
